import {
  Box,
  Button,
  IconButton,
  Snackbar,
  Typography,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { FormatDateMapper } from "nemuru-components";
import React from "react";

import Text from "../Text";
import { useNotificationSnackbar } from "./hooks/useNotificationSnackbar";
import { useStyles } from "./hooks/useStyles";

export function NotificationSnackbar({
  open,
  autoHide = false,
  onClose,
  message,
  errorObject = { status: undefined, data: undefined },
  onClick = () => {},
  level,
  ...props
}) {
  const { errorDetails, allowShowMoreButton, showMoreState, setShowMoreState } =
    useNotificationSnackbar(errorObject);

  const classes = useStyles();

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHide ? 5000 : 999999999}
      onClose={onClose}
      message={!level && message}
      onClick={onClick}
      {...props}
      className={classes.root}
    >
      {level && (
        <Alert
          aria-live="polite"
          aria-label={`Notification alert: ${message}`}
          severity={level}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={onClose}
            >
              <i
                className="material-icons-outlined"
                style={{ verticalAlign: "text-top", fontSize: "24px" }}
              >
                close
              </i>
            </IconButton>
          }
        >
          <div>
            <strong>{message}</strong>
          </div>
          {level === "error" && errorDetails && (
            <Box display={"flex"} flexDirection={"column"}>
              {errorDetails.errorSubmessage && (
                <small>
                  <Text tId={errorDetails.errorSubmessage} />
                </small>
              )}

              {errorDetails.date && (
                <small>
                  {
                    FormatDateMapper.hydrate(errorDetails.date)
                      .readableDateTimeWithSeconds
                  }
                </small>
              )}
              {errorDetails && (
                <small>
                  <Box>
                    <Box py={1}>
                      <strong>{errorDetails.errorTitle}:</strong>
                    </Box>
                    {errorDetails.detailsBody && (
                      <Box
                        id={"details-body"}
                        className={
                          showMoreState
                            ? classes.root
                            : `${classes.root} multiline-3rd-line-ellipsis overflow-text-ellipsis`
                        }
                        style={{
                          whiteSpace: "break-spaces",
                          textAlign: "initial",
                          maxWidth: "100%",
                          marginBottom: allowShowMoreButton ? "28px" : 0,
                          overflowWrap: "anywhere",
                        }}
                      >
                        {JSON.stringify(errorDetails.detailsBody, null, 2)}
                      </Box>
                    )}
                  </Box>
                </small>
              )}
              {allowShowMoreButton && (
                <Box position={"absolute"} bottom={"8px"} right={"8px"}>
                  <Button
                    size={"small"}
                    onClick={() => setShowMoreState(!showMoreState)}
                    style={{ maxWidth: "fit-content" }}
                  >
                    <Typography variant={"caption"}>
                      <Text
                        strong
                        tId={showMoreState ? "SHOW_LESS" : "SHOW_MORE"}
                      />
                    </Typography>
                  </Button>
                </Box>
              )}
            </Box>
          )}
        </Alert>
      )}
    </Snackbar>
  );
}
